<app-interview-sidebar>
  <div class="my-account-page full-width vertical">
    <div #userProfile></div>
  </div>
</app-interview-sidebar>
